/** Official = creation_source 'admin' (see programOrigin.ts). Visibility is ignored for official programs. */
export interface CatalogProgramRecord {
  creation_source?: string | null;
  is_published?: boolean | null;
  visibility?: string | null;
  program_scope?: string | null;
  program_type?: string | null;
  deleted_at?: string | null;
}

export function isOfficialCatalogProgram(program: CatalogProgramRecord, publishedByRpc = false, programType = 'powerprompt'): boolean {
  return ['powerprompt', 'course', 'challenge'].includes(programType)
    && program.creation_source === 'admin'
    && (program.is_published === true || (publishedByRpc && program.is_published === undefined))
    && !program.deleted_at
    && (program.program_scope ?? 'catalog') === 'catalog'
    && (program.program_type ?? programType) === programType;
}
